import React from 'react';
import { motion } from 'framer-motion';
import { RecoveryRing } from './ui/RecoveryRing';
export function Proof() {
  return <section className="py-24 relative overflow-hidden" data-id="element-170">
      <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-171" />

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4" data-id="element-174">
            What changes in 7 days
          </h2>
          <p className="text-xl text-brand-gray" data-id="element-175">Real data. Real results.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-176">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-brand-panel border border-brand-panelBorder rounded-3xl p-8 text-center flex flex-col items-center" data-id="element-177">
            <div className="mb-6" data-id="element-178">
              <RecoveryRing score={85} size={140} label="LATENCY" delay={0.2} data-id="element-179" />
            </div>
            <h3 className="text-2xl font-bold mb-2" data-id="element-180">Day 3</h3>
            <p className="text-brand-gray" data-id="element-181">
              Sleep Latency (time to fall asleep) typically drops under 15
              minutes.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-brand-panel border border-brand-green/30 rounded-3xl p-8 text-center flex flex-col items-center relative overflow-hidden" data-id="element-182">
            <div className="absolute inset-0 bg-brand-green/5" data-id="element-183" />
            <div className="mb-6 relative z-10" data-id="element-184">
              <RecoveryRing score={94} size={160} strokeWidth={10} label="HRV BOOST" delay={0.4} data-id="element-185" />
            </div>
            <h3 className="text-2xl font-bold mb-2 relative z-10" data-id="element-186">Day 7</h3>
            <p className="text-brand-gray relative z-10" data-id="element-187">
              Most users see a 15-20% increase in baseline HRV.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-brand-panel border border-brand-panelBorder rounded-3xl p-8 text-center flex flex-col items-center" data-id="element-188">
            <div className="mb-6" data-id="element-189">
              <RecoveryRing score={90} size={140} label="DEEP SLEEP" delay={0.6} data-id="element-190" />
            </div>
            <h3 className="text-2xl font-bold mb-2" data-id="element-191">Ongoing</h3>
            <p className="text-brand-gray" data-id="element-192">
              Significant expansion of Deep Sleep minutes on your dashboard.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}